import { render } from "./ListaVaga.vue?vue&type=template&id=5570b6b8&scoped=true"
import script from "./ListaVaga.vue?vue&type=script&lang=js"
export * from "./ListaVaga.vue?vue&type=script&lang=js"

import "./ListaVaga.vue?vue&type=style&index=0&id=5570b6b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5570b6b8"

export default script